// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/images/payment_modal_header.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-pro-stripe-payment-modal .modal__container {
    width: 50%;
    padding: 0;
    border-radius: 8px;
    height: 90%;
    max-width: 670px;
}

.baloa-pro-stripe-payment-modal .modal__container__close {
    background: transparent;
    color: var(--white-color);
}

.baloa-pro-stripe-payment-modal__header {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 150px;
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 50px;
    text-align: center;
}

.baloa-pro-stripe-payment-modal__header-title {
    display: flex;
    align-items: center;
    justify-content: center;
}

.baloa-pro-stripe-payment-modal__header-title .hubicon-award_star {
    font-size: 30px;
    margin-right: 8px;
}

.baloa-pro-stripe-payment-modal__header-title .baloa-headline-2 {
    color: var(--white-color);
    font-weight: var(--font-bold);
    line-height: normal;
}

.baloa-pro-stripe-payment-modal__header-message.baloa-username {
    color: var(--white-color);
}

.baloa-pro-stripe-payment-modal__header .hubicon-clear_option {
    color: var(--white-color);
    font-size: 24px;
    position: absolute;
    top: 15px;
    right: 14px;
    cursor: pointer;
}

.baloa-pro-stripe-payment-modal__content {
    height: calc(100vh - 60px);
}

.baloa-pro-stripe-payment-modal__form {
    padding: 18px 44px;
}

.baloa-pro-stripe-payment-modal__form .baloa-username{
    color: var(--primary-very-dark-color);
}

.baloa-pro-stripe-payment-modal__columns {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    margin-top: 20px;
}

.baloa-pro-stripe-payment-modal__columns label {
    width: 50%;
}

.baloa-pro-stripe-payment-modal__columns .baloa-username {
    color: var(--primary-very-dark-color);
}

.baloa-pro-stripe-payment-modal__country-select.input-field-auto-search {
    margin: 40px 0 20px 0;
}

.baloa-pro-stripe-payment-modal__country-select .MuiInputBase-root  {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    line-height: normal;
}

.baloa-pro-stripe-payment-modal__country-select .input-field-autocomplete-search label {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
    font-size: calc(var(--space-half-quarter) + var(--space-eighth));
}

.baloa-pro-stripe-payment-modal__country-select .MuiInputBase-input.MuiOutlinedInput-input {
    height: unset;
}

.baloa-pro-stripe-payment-modal__country-select .MuiFormControl-root .MuiFormLabel-root.Mui-focused {
    color: var(--primary-very-dark-color);
}

.baloa-pro-stripe-payment-modal__input.input-field{
    margin: 40px 0 20px 0;
}

.baloa-pro-stripe-payment-modal__input .input-field-label {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
    font-size: calc(var(--space-half-quarter) + var(--space-eighth));
}

.baloa-pro-stripe-payment-modal__input .input-field-input {
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    line-height: normal;
    max-height: unset;
    font-size: calc(var(--space-half-quarter) + var(--space-eighth));
    padding: var(--space) var(--space-half);
}

.baloa-pro-stripe-payment-modal__form .StripeElement {
    border: 1px solid var(--new-gray-background-color);
    padding: var(--space) 8px;
    border-radius: 8px;
    margin-top: 4px;
}

.baloa-pro-stripe-payment-modal__buttons {
    border-top: 1px solid var(--new-input-background-color);
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.baloa-pro-stripe-payment-modal__buttons .button.small {
    padding: 10px 20px;
}

.baloa-pro-stripe-payment-modal__conditions {
    padding: 0 44px 20px 44px;
}

.baloa-pro-stripe-payment-modal__conditions .baloa-table {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
    border-top: 1px solid var(--new-gray-background-color);
    padding-top: 20px;
}

.baloa-pro-stripe-payment-modal__conditions .baloa-username {
    color: var(--primary-dark-color);
    margin-top: 20px;
}

.baloa-pro-stripe-payment-modal__conditions .baloa-username a {
    color: var(--new-green-color);
}

.baloa-pro-stripe-payment-modal__error-message {
    border: 1px solid var(--error-color);
    border-radius: 4px;
    background: #FEF6F6;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 12px;
    margin: 0 44px 16px 44px;
}

.baloa-pro-stripe-payment-modal__error-message .hubicon-info::before{
    font-size: 24px;
    color: #E61920;
    margin-right: 10px;
}

.baloa-pro-stripe-payment-modal__error-message .baloa-table {
    font-weight: var(--font-medium);
    color: var(--primary-very-dark-color);
}

.baloa-pro-stripe-payment-modal__loading {
    border: 3px solid var(--primary-very-light-color); 
    border-top: 3px solid var(--basic-green-color);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    animation: spin 2s linear infinite;
    margin: 0 30px;
}

.baloa-pro-stripe-payment-modal__option-buttons__container {
    padding: 18px 44px 0 44px;
}

.baloa-pro-stripe-payment-modal__option-buttons.MuiFormControl-root .MuiFormGroup-root{
    justify-content: space-between;
}

.baloa-pro-stripe-payment-modal__option-buttons__button .MuiFormControlLabel-root {
    margin-left: 0;
    width: 100%;
    align-items: flex-start;
}

.baloa-pro-stripe-payment-modal__option-buttons__button .MuiFormControlLabel-root .MuiButtonBase-root.MuiRadio-root {
    padding: 0;
}

.baloa-pro-stripe-payment-modal__option-buttons__button .MuiFormControlLabel-root .MuiStack-root,
.baloa-pro-stripe-payment-modal__option-buttons__button .MuiFormControlLabel-root .MuiTypography-root {
    width: -webkit-fill-available;
}

.baloa-pro-stripe-payment-modal__option-buttons__button {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 14px;
    padding: 12px 16px;
    width: 48%;
    /* width: 100%; */ /*temporal por desactivacion suscripcion anual */
}
.baloa-pro-stripe-payment-modal__option-buttons__button.selected {
    border: 1px solid var(--new-green-color);
}

.baloa-pro-stripe-payment-modal__option-buttons__container .baloa-table {
    color: var(--primary-very-dark-color);
    margin-bottom: 12px;
    font-weight: var(--font-medium);
}

.baloa-pro-stripe-payment-modal__option-buttons__button .baloa-table-column {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.baloa-pro-stripe-payment-modal__option-buttons__button__label .baloa-names {
    color: var(--primary-very-dark-color);
}

.baloa-pro-stripe-payment-modal__option-buttons__button__label .baloa-table{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
    margin-top: 9px;
    margin-bottom: 9px;
}

.baloa-pro-stripe-payment-modal__option-buttons__button__label .baloa-table .strike {
    text-decoration: line-through;
}

.baloa-pro-stripe-payment-modal__conditions__new-subscriber__conditions .baloa-username {
    margin-top: 10px;
}

.baloa-pro-stripe-payment-modal__conditions__new-subscriber__conditions .baloa-username a {
    color: var(--new-green-color);
}

.baloa-pro-stripe-payment-modal__conditions .baloa-table.second-title {
    margin-top: 20px;
    border-top: none;
    padding-top: 0;
}

/* temporal por eliminacion desactivacion suscripcion anual*/
/* .baloa-pro-stripe-payment-modal__option-buttons {
    width: 100%;
} */

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .baloa-pro-stripe-payment-modal .modal__container {
        margin: 0;
        width: 100%;
        border-radius: 0;
        height: 100%;
    }

    .baloa-pro-stripe-payment-modal__header {
        height: 150px;
        padding-top: 30px;
    }

    .baloa-pro-stripe-payment-modal__header .hubicon-clear_option {
        color: var(--white-color);
        font-size: 24px;
        position: absolute;
        top: 3px;
        left: 5px;
        right: unset;
        cursor: pointer;
    }

    .baloa-pro-stripe-payment-modal__form {
        padding: 18px 24px;
    }

    .baloa-pro-stripe-payment-modal__input.input-field {
        margin: 30px 0 20px 0;
    }

    .baloa-pro-stripe-payment-modal__conditions {
        padding: 0 24px;
        /* position: fixed;
        bottom: 60px; */
    }

    .baloa-pro-stripe-payment-modal__buttons {
        position: fixed;
        bottom: 0;
        width: 100%;
    }

    .baloa-pro-stripe-payment-modal__buttons .button {
        width: 100%;
    }

    .baloa-pro-stripe-payment-modal__loading {
        border: 2px solid var(--primary-very-light-color);
        border-top: 2px solid var(--basic-green-color);
        width: 16px;
        height: 16px;
        margin: auto;
    }

    .baloa-pro-stripe-payment-modal__option-buttons__button {
        width: 100%;
        padding: 12px;
    }

    .baloa-pro-stripe-payment-modal__option-buttons.MuiFormControl-root .MuiFormGroup-root {
        gap: 12px
    }

    .baloa-pro-stripe-payment-modal__option-buttons__container {
        padding: 18px 24px 0 24px;
    }

    .baloa-pro-stripe-payment-modal__form {
        padding: 18px 24px;
    }

    .baloa-pro-stripe-payment-modal__option-buttons__button__label .baloa-table {
        margin-top: 4px;
        margin-bottom: 2px;
    }

    .baloa-pro-stripe-payment-modal__conditions__new-subscriber__conditions {
        padding-bottom: 16px;
    }

    .baloa-pro-stripe-payment-modal__content {
        height: calc(100vh - 210px);
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/baloa-pro/components/baloa-pro-stripe-payment-modal/BaloaProStripePaymentModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,yDAA+D;IAC/D,aAAa;IACb,4BAA4B;IAC5B,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,gEAAgE;AACpE;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,gEAAgE;AACpE;;AAEA;IACI,8BAA8B;IAC9B,kDAAkD;IAClD,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gEAAgE;IAChE,uCAAuC;AAC3C;;AAEA;IACI,kDAAkD;IAClD,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uDAAuD;IACvD,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;IAC/B,sDAAsD;IACtD,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,qCAAqC;AACzC;;AAEA;IACI,iDAAiD;IACjD,8CAA8C;IAC9C,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,kDAAkD;IAClD,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,iBAAiB,EAAE,gDAAgD;AACvE;AACA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,4DAA4D;AAC5D;;GAEG;;AAEH,yCAAyC,4BAA4B;;IAEjE;QACI,SAAS;QACT,WAAW;QACX,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,eAAe;QACf,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf;uBACe;IACnB;;IAEA;QACI,eAAe;QACf,SAAS;QACT,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iDAAiD;QACjD,8CAA8C;QAC9C,WAAW;QACX,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI;IACJ;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".baloa-pro-stripe-payment-modal .modal__container {\n    width: 50%;\n    padding: 0;\n    border-radius: 8px;\n    height: 90%;\n    max-width: 670px;\n}\n\n.baloa-pro-stripe-payment-modal .modal__container__close {\n    background: transparent;\n    color: var(--white-color);\n}\n\n.baloa-pro-stripe-payment-modal__header {\n    background-image: url('assets/images/payment_modal_header.png');\n    height: 150px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    padding-top: 50px;\n    text-align: center;\n}\n\n.baloa-pro-stripe-payment-modal__header-title {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.baloa-pro-stripe-payment-modal__header-title .hubicon-award_star {\n    font-size: 30px;\n    margin-right: 8px;\n}\n\n.baloa-pro-stripe-payment-modal__header-title .baloa-headline-2 {\n    color: var(--white-color);\n    font-weight: var(--font-bold);\n    line-height: normal;\n}\n\n.baloa-pro-stripe-payment-modal__header-message.baloa-username {\n    color: var(--white-color);\n}\n\n.baloa-pro-stripe-payment-modal__header .hubicon-clear_option {\n    color: var(--white-color);\n    font-size: 24px;\n    position: absolute;\n    top: 15px;\n    right: 14px;\n    cursor: pointer;\n}\n\n.baloa-pro-stripe-payment-modal__content {\n    height: calc(100vh - 60px);\n}\n\n.baloa-pro-stripe-payment-modal__form {\n    padding: 18px 44px;\n}\n\n.baloa-pro-stripe-payment-modal__form .baloa-username{\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-pro-stripe-payment-modal__columns {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    margin-top: 20px;\n}\n\n.baloa-pro-stripe-payment-modal__columns label {\n    width: 50%;\n}\n\n.baloa-pro-stripe-payment-modal__columns .baloa-username {\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-pro-stripe-payment-modal__country-select.input-field-auto-search {\n    margin: 40px 0 20px 0;\n}\n\n.baloa-pro-stripe-payment-modal__country-select .MuiInputBase-root  {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    line-height: normal;\n}\n\n.baloa-pro-stripe-payment-modal__country-select .input-field-autocomplete-search label {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth));\n}\n\n.baloa-pro-stripe-payment-modal__country-select .MuiInputBase-input.MuiOutlinedInput-input {\n    height: unset;\n}\n\n.baloa-pro-stripe-payment-modal__country-select .MuiFormControl-root .MuiFormLabel-root.Mui-focused {\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-pro-stripe-payment-modal__input.input-field{\n    margin: 40px 0 20px 0;\n}\n\n.baloa-pro-stripe-payment-modal__input .input-field-label {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth));\n}\n\n.baloa-pro-stripe-payment-modal__input .input-field-input {\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    line-height: normal;\n    max-height: unset;\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth));\n    padding: var(--space) var(--space-half);\n}\n\n.baloa-pro-stripe-payment-modal__form .StripeElement {\n    border: 1px solid var(--new-gray-background-color);\n    padding: var(--space) 8px;\n    border-radius: 8px;\n    margin-top: 4px;\n}\n\n.baloa-pro-stripe-payment-modal__buttons {\n    border-top: 1px solid var(--new-input-background-color);\n    padding: 12px 16px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.baloa-pro-stripe-payment-modal__buttons .button.small {\n    padding: 10px 20px;\n}\n\n.baloa-pro-stripe-payment-modal__conditions {\n    padding: 0 44px 20px 44px;\n}\n\n.baloa-pro-stripe-payment-modal__conditions .baloa-table {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n    border-top: 1px solid var(--new-gray-background-color);\n    padding-top: 20px;\n}\n\n.baloa-pro-stripe-payment-modal__conditions .baloa-username {\n    color: var(--primary-dark-color);\n    margin-top: 20px;\n}\n\n.baloa-pro-stripe-payment-modal__conditions .baloa-username a {\n    color: var(--new-green-color);\n}\n\n.baloa-pro-stripe-payment-modal__error-message {\n    border: 1px solid var(--error-color);\n    border-radius: 4px;\n    background: #FEF6F6;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 12px;\n    margin: 0 44px 16px 44px;\n}\n\n.baloa-pro-stripe-payment-modal__error-message .hubicon-info::before{\n    font-size: 24px;\n    color: #E61920;\n    margin-right: 10px;\n}\n\n.baloa-pro-stripe-payment-modal__error-message .baloa-table {\n    font-weight: var(--font-medium);\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-pro-stripe-payment-modal__loading {\n    border: 3px solid var(--primary-very-light-color); \n    border-top: 3px solid var(--basic-green-color);\n    border-radius: 50%;\n    width: 24px;\n    height: 24px;\n    animation: spin 2s linear infinite;\n    margin: 0 30px;\n}\n\n.baloa-pro-stripe-payment-modal__option-buttons__container {\n    padding: 18px 44px 0 44px;\n}\n\n.baloa-pro-stripe-payment-modal__option-buttons.MuiFormControl-root .MuiFormGroup-root{\n    justify-content: space-between;\n}\n\n.baloa-pro-stripe-payment-modal__option-buttons__button .MuiFormControlLabel-root {\n    margin-left: 0;\n    width: 100%;\n    align-items: flex-start;\n}\n\n.baloa-pro-stripe-payment-modal__option-buttons__button .MuiFormControlLabel-root .MuiButtonBase-root.MuiRadio-root {\n    padding: 0;\n}\n\n.baloa-pro-stripe-payment-modal__option-buttons__button .MuiFormControlLabel-root .MuiStack-root,\n.baloa-pro-stripe-payment-modal__option-buttons__button .MuiFormControlLabel-root .MuiTypography-root {\n    width: -webkit-fill-available;\n}\n\n.baloa-pro-stripe-payment-modal__option-buttons__button {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 14px;\n    padding: 12px 16px;\n    width: 48%;\n    /* width: 100%; */ /*temporal por desactivacion suscripcion anual */\n}\n.baloa-pro-stripe-payment-modal__option-buttons__button.selected {\n    border: 1px solid var(--new-green-color);\n}\n\n.baloa-pro-stripe-payment-modal__option-buttons__container .baloa-table {\n    color: var(--primary-very-dark-color);\n    margin-bottom: 12px;\n    font-weight: var(--font-medium);\n}\n\n.baloa-pro-stripe-payment-modal__option-buttons__button .baloa-table-column {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.baloa-pro-stripe-payment-modal__option-buttons__button__label .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-pro-stripe-payment-modal__option-buttons__button__label .baloa-table{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n    margin-top: 9px;\n    margin-bottom: 9px;\n}\n\n.baloa-pro-stripe-payment-modal__option-buttons__button__label .baloa-table .strike {\n    text-decoration: line-through;\n}\n\n.baloa-pro-stripe-payment-modal__conditions__new-subscriber__conditions .baloa-username {\n    margin-top: 10px;\n}\n\n.baloa-pro-stripe-payment-modal__conditions__new-subscriber__conditions .baloa-username a {\n    color: var(--new-green-color);\n}\n\n.baloa-pro-stripe-payment-modal__conditions .baloa-table.second-title {\n    margin-top: 20px;\n    border-top: none;\n    padding-top: 0;\n}\n\n/* temporal por eliminacion desactivacion suscripcion anual*/\n/* .baloa-pro-stripe-payment-modal__option-buttons {\n    width: 100%;\n} */\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .baloa-pro-stripe-payment-modal .modal__container {\n        margin: 0;\n        width: 100%;\n        border-radius: 0;\n        height: 100%;\n    }\n\n    .baloa-pro-stripe-payment-modal__header {\n        height: 150px;\n        padding-top: 30px;\n    }\n\n    .baloa-pro-stripe-payment-modal__header .hubicon-clear_option {\n        color: var(--white-color);\n        font-size: 24px;\n        position: absolute;\n        top: 3px;\n        left: 5px;\n        right: unset;\n        cursor: pointer;\n    }\n\n    .baloa-pro-stripe-payment-modal__form {\n        padding: 18px 24px;\n    }\n\n    .baloa-pro-stripe-payment-modal__input.input-field {\n        margin: 30px 0 20px 0;\n    }\n\n    .baloa-pro-stripe-payment-modal__conditions {\n        padding: 0 24px;\n        /* position: fixed;\n        bottom: 60px; */\n    }\n\n    .baloa-pro-stripe-payment-modal__buttons {\n        position: fixed;\n        bottom: 0;\n        width: 100%;\n    }\n\n    .baloa-pro-stripe-payment-modal__buttons .button {\n        width: 100%;\n    }\n\n    .baloa-pro-stripe-payment-modal__loading {\n        border: 2px solid var(--primary-very-light-color);\n        border-top: 2px solid var(--basic-green-color);\n        width: 16px;\n        height: 16px;\n        margin: auto;\n    }\n\n    .baloa-pro-stripe-payment-modal__option-buttons__button {\n        width: 100%;\n        padding: 12px;\n    }\n\n    .baloa-pro-stripe-payment-modal__option-buttons.MuiFormControl-root .MuiFormGroup-root {\n        gap: 12px\n    }\n\n    .baloa-pro-stripe-payment-modal__option-buttons__container {\n        padding: 18px 24px 0 24px;\n    }\n\n    .baloa-pro-stripe-payment-modal__form {\n        padding: 18px 24px;\n    }\n\n    .baloa-pro-stripe-payment-modal__option-buttons__button__label .baloa-table {\n        margin-top: 4px;\n        margin-bottom: 2px;\n    }\n\n    .baloa-pro-stripe-payment-modal__conditions__new-subscriber__conditions {\n        padding-bottom: 16px;\n    }\n\n    .baloa-pro-stripe-payment-modal__content {\n        height: calc(100vh - 210px);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
